export default __webpack_public_path__ + "static/media/dog_science_white.39cb043e.png";